// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mainChallanger {\r\n\tposition: absolute;\r\n\ttop: 96px;\r\n\ttext-align-last: center;\r\n\tright: 0px;\r\n\twidth: -moz-fit-content;\r\n\twidth: fit-content;\r\n}\r\n.mainChallangerInvisible {\r\n\tdisplay: none;\r\n}\r\n\r\n.imgChallenge {\r\n\theight: 31px;\r\n\tposition: relative;\r\n\tright: 222%;\r\n\ttop: -93px;\r\n\topacity: 0.3;\r\n\tvertical-align: text-bottom;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
